import { CDN_LINK } from "@globalConfig";
import stl from "./Disclaimer.module.css";
import { useTranslation } from "@i18n";

const Disclaimer = ({ className }) => {
  const { t } = useTranslation();
  return (
    <div className={`${stl.wrapper} ${className ? className : ""}`}>
      <img
        src={CDN_LINK + "/assets/images/safety.svg"}
        alt="safety icon"
        width={"20px"}
        height={"20px"}
      />
      <p>
        {t("شركة موقع سيارة للتجارة شركة موثقة لدى وزارة التجارة والاستثمار وبدعم منشركة علم.", {
          ns: "web_checkout_cash",
        })}
      </p>
      <img src={CDN_LINK + "/assets/images/info-icon-gray.svg"} alt="" />
    </div>
  );
};

export default Disclaimer;
